import { FC, memo } from 'react';

import { ImageComponent } from '@/components/Image';
import { TCardMode } from '@/modules/game/types';

import { ScEmptyGameCardContainer } from './styled';

interface IEmptyGameCardProps {
  mode: TCardMode;
}

export const EmptyGameCard: FC<IEmptyGameCardProps> = memo(({ mode }) => {
  return (
    <ScEmptyGameCardContainer className={mode} mode={mode}>
      <ImageComponent
        src="/game/empty-card-icon.svg"
        width="42"
        height="32"
        alt="empty game card icon"
      />
    </ScEmptyGameCardContainer>
  );
});
